import type { CompositeFilterDescriptor, SortDescriptor } from '@progress/kendo-data-query';
import type { GridPagerSettings, Page } from '@progress/kendo-react-grid';

/** GridPager settings. */
export const GRID_PAGER_SETTINGS = {
  buttonCount: 5,
  pageSizes: [10, 20, 50, 100],
} satisfies GridPagerSettings;

/** Default page. */
export const DEFAULT_PAGE: Page = {
  skip: 0,
  take: 10,
};

/** Default sort. */
export const DEFAULT_SORT: SortDescriptor[] = [];

/** Default filter. */
export const DEFAULT_FILTER: CompositeFilterDescriptor = {
  logic: 'and',
  filters: [],
} as const;
